/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    StorageNodeMini,
    StorageNodeMiniFromJSON,
    StorageNodeMiniFromJSONTyped,
    StorageNodeMiniToJSON,
} from './';

/**
 * 
 * @export
 * @interface BeeGFSNode
 */
export interface BeeGFSNode {
    /**
     * 
     * @type {StorageNodeMini}
     * @memberof BeeGFSNode
     */
    node?: StorageNodeMini | null;
    /**
     * 
     * @type {string}
     * @memberof BeeGFSNode
     */
    host: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BeeGFSNode
     */
    roles: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BeeGFSNode
     */
    addresses: Array<string>;
}

export function BeeGFSNodeFromJSON(json: any): BeeGFSNode {
    return BeeGFSNodeFromJSONTyped(json, false);
}

export function BeeGFSNodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): BeeGFSNode {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'node': !exists(json, 'node') ? undefined : StorageNodeMiniFromJSON(json['node']),
        'host': json['host'],
        'roles': json['roles'],
        'addresses': json['addresses'],
    };
}

export function BeeGFSNodeToJSON(value?: BeeGFSNode | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'node': StorageNodeMiniToJSON(value.node),
        'host': value.host,
        'roles': value.roles,
        'addresses': value.addresses,
    };
}


